import { Badge } from "~/components/shadcn/Badge";
import { cn } from "~/utils/fontsConfig";

type CountBadgeProps = {
    count?: number;
    className?: string;
};

const getBadgeStyle = (ticketCount?: number) => {
    if (!ticketCount) return { backgroundColor: "#9BE1E3", color: "#0F1114" };
    if (ticketCount >= 5) {
        return { backgroundColor: "#04DB8E", color: "#0F1114" };
    } else if (ticketCount >= 3) {
        return { backgroundColor: "#8058F6", color: "#0F1114" };
    } else if (ticketCount >= 2) {
        return { backgroundColor: "#2486F8", color: "#0F1114" };
    }
    return { backgroundColor: "#9BE1E3", color: "#0F1114" };
};

export const CountBadge = ({ count, className }: CountBadgeProps) => {
    if (!count) return null;

    return (
        <Badge
            variant="secondary"
            className={cn("px-1.5 py-0.5", className)}
            style={getBadgeStyle(count)}
        >
            {count}x
        </Badge>
    );
};
